module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.selectedItem) ? _c('div', {
    staticClass: "grtid-menu-header",
    style: ({
      color: _vm.fontColor
    })
  }, [_c('button', {
    staticClass: "back",
    on: {
      "click": function($event) {
        _vm.selectedItem = null
      }
    }
  }, [_c('span', {
    staticClass: "dbc-icon dbc-icon-arrow-left"
  }), _vm._v(" "), _c('span', [_vm._v("Back")])]), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.selectedItem.text))])]) : _vm._e(), _vm._v(" "), _c('grid-items', {
    attrs: {
      "items": !_vm.selectedItem ? _vm.items : _vm.selectedItem.children,
      "iconColor": _vm.iconColor,
      "fontColor": _vm.fontColor
    },
    on: {
      "onClick": _vm.onItemClick,
      "onSelect": function($event) {
        return _vm.onItemSelect($event)
      }
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-54b63dd2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54b63dd2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/home-page-components/grid-menu-component.vue
// module id = 777
// module chunks = 0